import { Button } from "primereact/button";
import { BUTTONS, CRIAR_OBRA } from "../../nova-obra.constants";
import { DivergenciasEquipeDialogs } from "./components/divergencias-equipe-dialogs";
import { JustificativaCondicoesDialog } from "./components/justificativa-condicoes-dialog";
import type { CriarObraAcaoProps, CriarObraAcaoViewModel } from "./types-criar-obra-acao";

/**
 * Botão "Criar Obra" da Revisão (HU 2543): única gravação do wizard. Com condição de limite/contrato
 * pendente abre antes a modal de justificativa da HU 2549. Só cria com a verificação das condições
 * concluída: carregando ou com erro, o botão fica desabilitado (a Revisão explica o motivo).
 * O 409 de divergência da equipe reabre os diálogos de conflito/indisponibilidade (HU 2530 RN08).
 */
export function CriarObraAcaoView(props: CriarObraAcaoProps & CriarObraAcaoViewModel) {
  const {
    state,
    justificar,
    status,
    periodo,
    hoje,
    condicoes,
    catalogo,
    salvando,
    justificando,
    fecharJustificativa,
    ajustarDatas,
    adicionarTipo,
    divergencias,
    fecharDivergencias,
    reenviarComJustificativaEquipe,
    criar,
    className,
  } = props;

  return (
    <>
      <Button
        type="button"
        label={salvando ? CRIAR_OBRA.criando : BUTTONS.criarObra}
        loading={salvando}
        onClick={criar}
        disabled={status !== "ok" || salvando}
        className={className}
        data-testid="criar-obra"
      />
      {justificando && periodo && (
        <JustificativaCondicoesDialog
          condicoes={condicoes}
          periodo={periodo}
          hoje={hoje}
          catalogo={catalogo.data}
          justificativaInicial={state.justificativaCondicoes}
          onJustificar={justificar}
          onAjustarDatas={ajustarDatas}
          onAdicionarTipo={adicionarTipo}
          onClose={fecharJustificativa}
        />
      )}
      {divergencias && (
        <DivergenciasEquipeDialogs
          divergencias={divergencias}
          onConfirmar={reenviarComJustificativaEquipe}
          onVoltar={fecharDivergencias}
        />
      )}
    </>
  );
}
